import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import {
  DialogContentBase, DialogModule, DialogRef,
  KENDO_DIALOGS,
} from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { EditorModule } from '@progress/kendo-angular-editor';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import {AutoFocusDirective} from '../../directives/auto-focus.directive';
import {DisciplineType} from '../../models/models.lib';
import {LoggerService} from '../../shared/logger.service';
import {CasiCloseOptions, FormModes} from '../../common/constants.lib';


@Component({
  selector: 'casi-discipline-edit',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    DialogModule,
    EditorModule,
    InputsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    LayoutModule,
    AutoFocusDirective,
    KENDO_DIALOGS
  ],
  templateUrl: './discipline-edit.component.html',
  styleUrl: './discipline-edit.component.scss'
})
export class DisciplineEditComponent extends DialogContentBase implements OnInit {

  private _discipline: DisciplineType | undefined;

  @Input() title: string = 'Title Not Set';

  @Input({ required: true }) set discipline(val: DisciplineType) {
    this._discipline = val;
    this.disciplineForm.patchValue(this._discipline);
  }
  get discipline(): DisciplineType | undefined {
    return this._discipline;
  };

  private _mode: FormModes = FormModes.NOTSET;
  @Input({ required: true }) set mode(val: FormModes) {
    this._mode = val;
  }
  get mode(): FormModes {
    return this._mode;
  };

  disciplineForm: FormGroup;

  constructor(
    public override dialog: DialogRef,
    private fb: FormBuilder,
    private logger: LoggerService,
  ) {
    super(dialog);
    this.disciplineForm = this.fb.group(
      {
        id: [null, []],
        discipline_name: [null, [Validators.required]]
      }
    );
  }

  //#region Form

  get f() {
    return this.disciplineForm.controls;
  }
  get discipline_name() {
    return this.disciplineForm.get('discipline_name');
  }

  //#endregion

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
  }

  public onCancelAction(): void {
    this.logger.debug(`onCancelAction...`);
    this.dialog.close({ text: CasiCloseOptions.Cancelled });
  }

  public onSaveAction(): void {
    this.logger.debug(`onSaveAction...`, this.disciplineForm.value);
    if (this.disciplineForm.status !== 'INVALID')
      this.dialog.close({ text: CasiCloseOptions.Saved });
  }
}

